import { usePageTitle } from '@/hooks/usePageTitle';
import { useNavigate } from 'react-router-dom';
import { Home } from 'lucide-react';
import { Button } from '@/components/ui/button';

function NotFoundPage() {
  usePageTitle('Pagina niet gevonden');
  const navigate = useNavigate();

  return (
    <div className="container mx-auto max-w-sm px-4">
      <div className="flex flex-col items-center justify-center min-h-screen text-center">
        <h1 className="text-8xl font-bold tracking-tight mb-2">404</h1>
        <h2 className="text-xl font-semibold mb-2">Pagina niet gevonden</h2>
        <p className="text-muted-foreground mb-8">
          De pagina die je zoekt bestaat niet of is verplaatst.
        </p>
        <Button size="lg" onClick={() => navigate('/quotes')}>
          <Home className="mr-2 h-4 w-4" />
          Naar offerte-overzicht
        </Button>
      </div>
    </div>
  );
}

export default NotFoundPage;
